import { FC, useEffect } from 'react';
import { IlogisticServiceDetails, LIST_OF_QUOTE_STATUSES } from '../../../../types/services';
import { TAX_MANAGEMENT_OPTIONS } from '../../../../types/global';
import InvoiceSectionOfBillingTab from 'components/InvoiceSectionOfBillingTab/InvoiceSectionOfBillingTab';
import useInvoicesState from 'state/useInvoicesState';
import './BillingFileComponent.scss';
import { LOGISTIC_SERVICE_STATUS_NAME } from 'types/suscription/history.types';

const BillingFileComponent: FC<IBillingFileComponent> = ({
  logisticServiceData,
  updateWithoutLoader
}: IBillingFileComponent) => {
  const {
    id,
    billingCountry,
    billingMethod,
    invoiceNumber: invoiceNumberDefault,
    invoiceEmissionDate: invoiceEmissionDateDefault,
    isPaymentAgreement,
    hasActiveCredit,
    paymentAgreementDate,
    paymentAgreementDays,
    organization,
    needInvoice,
    quotesLog,
    manualQuote,
    statusName
  } = logisticServiceData;

  const { billingProvider } = billingMethod || {};

  const {
    setLogisticServiceId,
    setOrganizationName,
    setPaymentAgreementDate,
    setPaymentAgreementDays,
    setHasActiveCredit,
    setIsPaymentAgreement,
    setInvoiceType
  } = useInvoicesState();

  const taxType = billingMethod?.taxManagementName;
  // Determina si se necesita factura y la cotización no está pendiente o no hay cotización manual
  const needInvoiceAndQuoteIsNotPending =
    needInvoice &&
    ((manualQuote &&
      quotesLog?.status !== LIST_OF_QUOTE_STATUSES.PENDING &&
      statusName !== LOGISTIC_SERVICE_STATUS_NAME.TO_CONFIRMED) ||
      !manualQuote);

  const invoicingMethodsWithIVA =
    taxType &&
    [
      TAX_MANAGEMENT_OPTIONS.BREAK_DOWN_ECOMMERCE_TAX,
      TAX_MANAGEMENT_OPTIONS.COMPLETE_TAXES_AFTER_ORDER_CREATION
    ].includes(taxType);

  const updateInvoiceStates = () => {
    setLogisticServiceId(Number(id));
    setOrganizationName(organization?.organizationName || '');
    setPaymentAgreementDate(paymentAgreementDate || '');
    setPaymentAgreementDays(paymentAgreementDays || 0);
    setHasActiveCredit(hasActiveCredit || false);
    setIsPaymentAgreement(isPaymentAgreement || false);
    setInvoiceType('logistic-service');
  };

  useEffect(() => {
    updateInvoiceStates();
  }, [logisticServiceData]);

  return (
    <div id="billingFileComponent">
      <InvoiceSectionOfBillingTab
        logisticServiceId={Number(id)}
        companyName={billingMethod?.beneficiary || ''}
        emissionCountry={billingCountry?.name || ''}
        emissionCountryFlag={billingCountry?.flag || ''}
        billingCountry={billingCountry}
        hasIVA={invoicingMethodsWithIVA || false}
        variant="logistic-service"
        needInvoice={needInvoiceAndQuoteIsNotPending || false}
        billingProvider={billingProvider}
      />
    </div>
  );
};

export default BillingFileComponent;

interface IBillingFileComponent {
  logisticServiceData: IlogisticServiceDetails;
  updateWithoutLoader?: () => void;
}
